export enum QueryKey {
  ACTIVITY = 'activity',
  CHEMICAL_PRODUCT = 'chemicalProducts',
  RISK_ASSESSMENT = 'riskAssessment',
  ACTION = 'action',
  ACTION_INITIAL = 'actionInitial',
  TRACEABILITY = 'traceability',
  GET_TRACEABILITY_INITIAL = 'getTraceabilityInitial',
  TRACEABILITY_INITIAL = 'traceabilityInitial',
  ACTIVITY_VIEW = 'activityView',
  REPORTS = 'reports',
  ACTIVITY_PDF = 'activities-pdf',
  ACTIVITY_CREATE = 'create',
  ACTION_ALL = 'action/all',
  RELEASE_ACTIVITY = 'releaseActivity',
  RELEASE_ACTIONS = 'releaseAction',
  ACTIVITY_INTIAL_DATA = 'activityIntialData',
  RISK_ASSESSMENT_INITIAL_DATA = 'riskAssessmentInital',
  ACTIVITY_TRACEABILITY = 'activityTraceability',
  ACTIVITY_POST = 'activityPost',
  RISK_ASSESSMENT_POST = 'riskAssessmentPost',
  ACTIVITY_CLONE_POST = 'activityClonePost',
  ACTIVITY_TRACEABILITY_POST = 'activityTraceabilityPost',
  DEPARTMENTS = 'departments',
  DISTRIBUTION_LIST_PREFILL = 'distributionListPreFill',
}
